import "./add.css"
import { Form, Input, Button, Checkbox, Space, Select } from "antd";
import { MinusCircleOutlined, PlusOutlined, ArrowUpOutlined, ArrowDownOutlined, LinkOutlined, MinusOutlined } from '@ant-design/icons';
import { Tool } from "../../services/Tool";
const { TextArea } = Input;


function TableForm({ title, name, tools }: { title: string, name: string, tools: Tool[] }) {

    return (
        <>
            <div
                style={{ display: 'flex', justifyContent: 'center', fontWeight: 500, fontSize: 20, marginBottom: 8, marginTop: 16 }}>
                {title}
            </div>
            <div className="table-header-custom">
                <div className="table-header-item" style={{ width: '5%' }}> No. </div>
                <div className="table-header-item" style={{ width: '5%' }}> Flow </div>
                <div className="table-header-item" style={{ width: '15%' }}> Action to be taken </div>
                <div className="table-header-item" style={{ width: '14%' }}> Application /Tool</div>
                <div className="table-header-item" style={{ width: '14%' }}> Responsible</div>
                <div className="table-header-item" style={{ width: '13%' }}> Timeline </div>
                <div className="table-header-item" style={{ width: '17%' }}> Comments </div>
                <div className="table-header-item" style={{ width: '22%' }}> Links </div>
                <div className="table-header-item" style={{ width: '3%' }}>  </div>
            </div>
            
            <Form.List name={name}>
                {(fields, { add, remove, move }) => (
                    <div className="form-list-custom">
                        <div className="table-wrap-custom">
                            {fields.map(({ key, name, ...restField }, index) => (
                                <div key={key} className="row-c" >
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'order']}
                                        style={{ width: '60px', padding: 8, marginBottom: 0, textAlign: 'center' }}
                                    >
                                        {index + 1}
                                    </Form.Item>
                                    <Form.Item
                                        name={[name, 'flowInclude']}
                                        style={{ paddingLeft: 16, paddingRight: 16, paddingTop: 8, marginBottom: 0 }}
                                        valuePropName="checked"
                                    >
                                        <Checkbox></Checkbox>
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'action']}
                                        style={{ flex: 1, marginBottom: 0, width: '100px'}}
                                    >
                                        <TextArea rows={6} placeholder="Action to be taken" />
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'application']}
                                        style={{ width: '100px', padding: '8px', marginBottom: 0 }}
                                    >
                                        <Select allowClear>
                                            {tools.map(tool =>
                                                <Select.Option
                                                    value={tool._id}
                                                    key={tool._id}
                                                    style={{ backgroundColor: tool.color }}
                                                >
                                                    {tool.title}
                                                </Select.Option>)
                                            }
                                        </Select>
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'responsible']}
                                        style={{ flex: 1, marginBottom: 0 }}
                                    >
                                        <TextArea rows={6} placeholder="Responsible" />
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'triggerStage']}
                                        style={{ marginBottom: 0, width: '90px'}}
                                    >
                                        <TextArea rows={6} placeholder="Timeline" />
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'comments']}
                                        style={{ flex: 1, marginBottom: 0 }}
                                    >
                                        <TextArea rows={6} placeholder="Comments" />
                                    </Form.Item>
                                    <Form.List name={[name, 'links']}>
                                        {(linkFields, { add: addLink, remove: removeLink }) => (
                                            <div className="link-list">
                                                {linkFields.map(({ key: linkKey, name: linkName, ...linkRestField }) => (
                                                    <div key={linkKey} style={{ display: 'flex', alignItems: 'flex-start', justifyContent:'center', minWidth:'150px' }}>
                                                        <Form.Item
                                                            {...linkRestField}
                                                            name={[linkName, 'title']}
                                                            style={{ flex: 1, marginRight: 8, border: 'none' }}
                                                            rules={[{required: true, message: 'Please input title'}]}
                                                        >
                                                            <Input placeholder="Title"  style={{borderRadius:5, border:'1px solid lightgray !important'}}/>
                                                        </Form.Item>
                                                        <Form.Item
                                                            {...linkRestField}
                                                            name={[linkName, 'link']}
                                                            style={{ flex: 1, marginRight: 8,  border: 'none' }}
                                                            rules={[{required: true, message: 'Please input URL'}, {type: 'url', message: 'Please input valid URL'}]}
                                                        >
                                                            <Input placeholder="URL"  style={{borderRadius:5, border:'1px solid lightgray !important'}} />
                                                        </Form.Item>
                                                        <MinusOutlined onClick={() => removeLink(linkName)} style={{marginTop: 8}}/>
                                                    </div>
                                                ))}
                                                <Form.Item style={{border: 'none'}}>
                                                    <Button type="primary" onClick={() => addLink()} block icon={<LinkOutlined />} ghost>
                                                        Add Link
                                                    </Button>
                                                </Form.Item>
                                            </div>
                                        )}
                                    </Form.List>
                                    
                                    <Space direction="vertical" style={{ padding: 8 }}>
                                        {index != 0 && <ArrowUpOutlined onClick={() => move(index, index - 1)} />}
                                        <MinusCircleOutlined onClick={() => remove(name)} />
                                        {index != fields.length - 1 && <ArrowDownOutlined onClick={() => move(index, index + 1)} />}
                                    </Space>

                                    
                                </div>
                            ))}
                        </div>
                        <Form.Item>
                            <Button onClick={() => add()} block icon={<PlusOutlined />} style={{ marginTop: 16 }} type="primary" ghost>
                                Add Row
                            </Button>
                        </Form.Item>
                    </div>
                )}
            </Form.List>
        </>

    );
}

export default TableForm;